<template>
  <div class="flex items-center cell cell-renderer-trash">
    <div class="flex items-center pm-ag-grid-inner-cell functions">
      <div class="trash-icon mr-2">
        <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererTrash",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.cell-renderer-trash {
  width: 100%;

  .cell {
    width: inherit;
  }

  .pm-ag-grid-inner-cell {
    height: 100%;
    width: 100%;
  }

  .trash-icon {
    cursor: pointer;
    padding-left: 15px;
  }
}
</style>
